import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// Overview is the landing route — ships in the main bundle (NOT lazy) and
// renders directly with the shell. Local-first (SQLite reads resolve in ~50ms),
// so no <Suspense> skeleton wraps it.
import { Overview } from "@/features/workforce/components/overview";

function OverviewPage() {
  return <Overview />;
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: OverviewPage,
});
